export class User {
  
  constructor() {
    this.email = '';
    this.token = '';
    this.username = ''; 
     
  }  
}
